'use client';

import { styled } from 'core/styles';

export const BgContainer = styled('div', { shouldForwardProp: prop => prop !== 'zeroPadding' })<{
  zeroPadding?: boolean;
}>(({ zeroPadding, theme }) => ({
  borderRadius: 16,
  padding: zeroPadding ? 0 : 16,
  background: theme.palette.background.paper,
}));
